<script>
import NoData from "@/components/common/NoData.vue";
import Loading from "@/components/common/Loading.vue";

import { getMeetingList } from "@/api/index.js";

export default {
  components: { NoData, Loading },
  data() {
    return {
      loading: false,
      meetingList: [],
      meetingListParty: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      getMeetingList()
        .then((res) => {
          const { code, msg, msg2 } = res;
          this.meetingList = code === 0 ? msg || [] : [];
          this.meetingListParty = code === 0 ? msg2 || [] : [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toVideoDetail({ Vid }) {
      this.$router.push({
        path: "videoDetail",
        query: { id: Vid, title: "视频播放" },
      });
    },
  },
};
</script>

<template>
  <div class="meeting-container">
    <img
      :src="require('@/assets/index/meeting-banner.webp')"
      alt="meeting-banner"
      class="meeting-banner"
    />
    <div class="main-content">
      <div
        class="list-container"
        :class="{ 'list-container-center': !meetingList.length }"
      >
        <p class="category-title">乡科级以下干部、党员培训课程</p>
        <div v-if="!loading && meetingList.length > 0" class="meeting-list">
          <div
            v-for="v in meetingList"
            :key="v.Vid"
            class="meeting-item"
            @click="toVideoDetail(v)"
          >
            <img
              :src="v.VideoImage | img2"
              alt="meeting-cover"
              class="meeting-cover"
            />
            <p class="meeting-title h-line-2">{{ v.VideoTitle || "" }}</p>
          </div>
        </div>
        <NoData v-if="!loading && !meetingList.length" />
        <Loading v-if="loading" />
      </div>
      <!-- <div class="list-container" :class="{'list-container-center': !meetingListParty.length}">
        <p class="category-title">党员培训课程</p>
        <div v-if="!loading && meetingListParty.length > 0" class="meeting-list">
          <div v-for="v in meetingListParty" :key="v.Vid" class="meeting-item" @click="toVideoDetail(v)">
            <img :src="v.VideoImage | img2" alt="meeting-cover" class="meeting-cover">
            <p class="meeting-title h-line-2">{{ v.VideoTitle || '' }}</p>
          </div>
        </div>
        <NoData v-if="!loading && !meetingListParty.length" />
        <Loading v-if="loading" />
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.meeting-container {
  font-size: 0.3rem;
  padding-top: 0.9rem;
  overflow-y: scroll;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .meeting-banner {
    width: 7.5rem;
    height: 4.76rem;
    position: absolute;
    top: 0.73rem;
    z-index: -1;
  }
}
.main-content {
  width: 100%;
  background-color: #fafafa;
  padding: 0.4rem 0.2rem 1rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin-top: 4.23rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  .list-container {
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
  }
  .list-container-center {
    align-items: center;
  }
  .category-title {
    width: 100%;
    font-size: 0.32rem;
    font-weight: bold;
    color: #1b0707;
  }
  .meeting-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem 0.1rem;
    .meeting-item {
      width: 3.5rem;
      min-height: 4rem;
      border-radius: 0 0 0.1rem 0.1rem;
      padding: 0 0.2rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 0.2rem;

      font-size: 0.26rem;
      color: #000;
      .meeting-cover {
        width: 3.5rem;
        height: 2.7rem;
        object-fit: cover;
      }
    }
  }
}
</style>
